import { createExperimentsDescriptor } from '@johnlewispartnership/wtr-website-decisioner-client/express';

export type ExperimentsDescriptor<
  V extends {
    default: string;
    [x: string]: string;
  } = {
    default: string;
  },
> = {
  experiment: string;
  variant: V;
};

export const MONETATE_DEFAULT_VARIANT = 'default';

export const AGENTIC_SHOPPING_SHOP_BY_LIST: ExperimentsDescriptor = createExperimentsDescriptor(
  'agenticShopping_shopByList',
  {
    default: MONETATE_DEFAULT_VARIANT,
    add: 'add',
    preselect: 'preselect',
  },
);

export const EOS_NEW_HEADER: ExperimentsDescriptor = createExperimentsDescriptor('EoS_newHeader', {
  default: MONETATE_DEFAULT_VARIANT,
  showNewHeader: 'showNewHeader',
});

export const monetateExperiments = [AGENTIC_SHOPPING_SHOP_BY_LIST, EOS_NEW_HEADER];
